import axios from 'axios';

const startExecution = async (data) => {
    try {
        await axios.post('/import', data);
    return [];
  } catch (error) {
    console.error(error);
    const msg = error?.response?.data?.message?.error ?? error?.message ?? 'Import failed';
    return [{ _error: msg }];
  }
};

export const importActions = {
    startExecution,
};
